import { DynamicStandaloneCheckbox } from '@/components/Checkbox';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorCheckbox: LabradorComponent = ({ type, data, meta }) => {
  return <DynamicStandaloneCheckbox label={data.label} options={data.options} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorCheckbox;
